import i18n from '@/utils/i18n';
import React from 'react';
import SearchIcon from '@assets/icons/search.svg';
import { EmptyState } from '@/components/empty-state';
import { useTheme } from '@/contexts/theme-context';

export const UnifiedSearchEmptyState: React.FC = () => {
  const theme = useTheme();
  return (
    <EmptyState
      description={i18n.t('search_catalog_empty_state')}
      icon={
        <SearchIcon fill={theme.sk.color.icon.primary} height={30} width={30} />
      }
      title={i18n.t('search_catalog')}
    />
  );
};
